//==========import components===============
import SubPagesLayout from 'layouts/SubPagesLayout';
import AboutEvent from 'components/common/AboutEvent';
import JoinEventOrganizer from 'components/common/JoinEventOrganizer';
import SuccessStoriesTab from 'components/about-us/success-stories/SuccessStoriesTab';
import { ourSuccessPageEventObj } from 'helpers/commonHelper';
import SuccessStoriesRating from 'components/about-us/success-stories/SuccessStoriesRating';

const SuccessStories = () => {
  return (
    <div className='successStoriesPage DBlock relative'>
      <AboutEvent data={ourSuccessPageEventObj} />
      <SuccessStoriesTab />
      <SuccessStoriesRating />
      <JoinEventOrganizer />
    </div>
  );
};

export default SubPagesLayout({ route: 'about us/success stories' })(
  SuccessStories
);
